module.exports = __webpack_public_path__ + "static/fonts/HelveticaNeueCyr-Roman.f5609db.ttf";